import { EMAIL_REGEX, LOGIN_FIELDS, POSTAL_CODE_REGEX, SIGNUP_STEP_FIELDS, TAX_CODE_REGEX, TOTAL_SIGNUP_STEPS } from './validation.constants'
import type { CustomerAuthField, CustomerAuthFieldErrorMap, CustomerAuthValues } from './validation.types'

export type { ValidationMessageKey, CustomerAuthField, CustomerAuthFieldErrorMap, CustomerAuthValues } from './validation.types'
export { TOTAL_SIGNUP_STEPS, SIGNUP_STEP_FIELDS, LOGIN_FIELDS } from './validation.constants'

export const INITIAL_CUSTOMER_AUTH_VALUES: CustomerAuthValues = {
  email: '',
  password: '',
  confirmPassword: '',
  firstName: '',
  lastName: '',
  taxCode: '',
  gender: '',
  phonePrefix: '+39',
  phoneLocalNumber: '',
  addressStreet: '',
  addressStreetNumber: '',
  addressCity: '',
  addressPostalCode: '',
  addressProvince: '',
  addressCountry: 'IT',
}

export const hasFieldErrors = (errors: CustomerAuthFieldErrorMap) => Object.keys(errors).length > 0

export const resolveSignupStepErrors = (
  step: number,
  values: CustomerAuthValues,
): CustomerAuthFieldErrorMap => {
  const errors: CustomerAuthFieldErrorMap = {}

  if (step === 1) {
    if (!values.firstName.trim()) errors.firstName = 'customer.auth.validation.requiredField'
    if (!values.lastName.trim()) errors.lastName = 'customer.auth.validation.requiredField'

    if (!values.taxCode.trim()) {
      errors.taxCode = 'customer.auth.validation.requiredField'
    } else if (!TAX_CODE_REGEX.test(values.taxCode.trim().toUpperCase())) {
      errors.taxCode = 'customer.auth.validation.taxCodeInvalid'
    }

    if (!values.email.trim()) {
      errors.email = 'customer.auth.validation.requiredField'
    } else if (!EMAIL_REGEX.test(values.email.trim())) {
      errors.email = 'customer.auth.validation.emailInvalid'
    }

    if (!values.gender.trim()) errors.gender = 'customer.auth.validation.genderRequired'
    return errors
  }

  if (step === 2) {
    const normalizedPhoneDigits = values.phoneLocalNumber.replace(/[^\d]/g, '')
    if (!values.phonePrefix.trim()) {
      errors.phonePrefix = 'customer.auth.validation.requiredField'
    }
    if (!values.phoneLocalNumber.trim()) {
      errors.phoneLocalNumber = 'customer.auth.validation.requiredField'
    } else if (normalizedPhoneDigits.length < 6 || normalizedPhoneDigits.length > 14) {
      errors.phoneLocalNumber = 'customer.auth.validation.phoneInvalid'
    }

    if (!values.addressStreet.trim()) errors.addressStreet = 'customer.auth.validation.requiredField'
    if (!values.addressStreetNumber.trim()) errors.addressStreetNumber = 'customer.auth.validation.requiredField'
    if (!values.addressCity.trim()) errors.addressCity = 'customer.auth.validation.requiredField'
    if (!values.addressProvince.trim()) errors.addressProvince = 'customer.auth.validation.requiredField'
    if (!values.addressCountry.trim()) errors.addressCountry = 'customer.auth.validation.requiredField'

    const normalizedPostalCode = values.addressPostalCode.replace(/\s+/g, '').trim()
    if (!normalizedPostalCode) {
      errors.addressPostalCode = 'customer.auth.validation.requiredField'
    } else if (!POSTAL_CODE_REGEX.test(normalizedPostalCode)) {
      errors.addressPostalCode = 'customer.auth.validation.postalCodeInvalid'
    }

    return errors
  }

  if (step === 3) {
    return errors
  }

  return errors
}

export const resolveLoginErrors = (values: CustomerAuthValues): CustomerAuthFieldErrorMap => {
  const errors: CustomerAuthFieldErrorMap = {}

  if (!values.email.trim()) {
    errors.email = 'customer.auth.validation.requiredField'
  }

  if (!values.password.trim()) {
    errors.password = 'customer.auth.validation.requiredField'
  }

  return errors
}
